import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReturnNav from 'brastrap/common/return-nav/ReturnNav';
import Action from 'brastrap/common/action/Action';
import { applyModifiers } from '../../utils';

const CLASS_NAME = 'c-modal';

const Modal = props => {
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape' && props?.actions?.dismiss?.onClick) {
        props.actions.dismiss.onClick(event);
      }
    };

    if (props?.isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [props?.isOpen]);

  const modalId = props?.modalId;

  const modalIdProps = {};
  if (modalId) {
    modalIdProps.id = modalId;
  }

  return (
    <div
      role="dialog"
      aria-labelledby="modalId"
      aria-modal="true"
      className="c-modal__container"
      data-open={props?.isOpen}
    >
      <div
        className={applyModifiers(CLASS_NAME, props?.modifiers)}
        data-open={props?.isOpen}
        {...modalIdProps}
        style={{ background: props?.backgroundColour }}
      >
        {(props?.title || props?.actions) && (
          <header className="c-modal__header" id="modalId">
            {props?.title && <h2 className="c-modal__title">{props?.title}</h2>}

            {props?.actions && (
              <div className="c-modal__actions">
                {props?.actions?.returnNav && (
                  <ReturnNav {...props?.actions?.returnNav} />
                )}
                {props?.actions?.dismiss && (
                  <Action
                    {...props?.actions?.dismiss}
                    modifiers={['dismiss']}
                    isOpen={props?.isOpen}
                    id={`${modalId}-dismiss`}
                  />
                )}
              </div>
            )}
          </header>
        )}

        <div className="c-modal__main">{props?.children}</div>

        {Array.isArray(props?.footer) && (
          <div className="c-modal__footer">
            {props?.footer?.map((element, key) => {
              if (React.isValidElement(element)) {
                return React.cloneElement(element, { key });
              }
              return null;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  modalId: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  backgroundColour: PropTypes.string,
  title: PropTypes.node,
  actions: PropTypes.shape({
    returnNav: PropTypes.object,
    dismiss: PropTypes.shape({
      onClick: PropTypes.func,
    }),
  }),
  footer: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.node,
};

Modal.defaultProps = {
  isOpen: false,
  modalId: null,
  modifiers: [],
  backgroundColour: 'white',
  title: null,
  actions: null,
  footer: null,
};

export default Modal;
